<template>
  <div class="login-page">
    <!-- Navbar -->
    <nav class="navbar navbar-expand-lg navbar-absolute fixed-top navbar-transparent">
      <div class="container">
        <div class="navbar-wrapper w-100">
          <a class="navbar-brand w-100" href="https://www.bigscoots.com/" target="_blank">
            <img src="../assets/img/bigscoots-logo/logo_light.svg" alt="Bigscoots" width="70%" class="center login-bs-logo">
          </a>
        </div>
      </div>
    </nav>
    <!-- End Navbar -->
    <div class="wrapper wrapper-full-page ">
      <div class="full-page section-image">
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <div class="card"  v-if="!loading">
                <!-- Show the loader when async operation is going on -->
                <div class="loader"></div>
              </div>
              <form v-else class="form" @submit.prevent="verifycode">
                <div class="card card-login">
                  <div class="card-header ">
                    <div class="card-header ">
                      <h3 class="header text-center">Two Factor Authentication</h3>
                      <p>{{display_msg}}</p>
                    </div>
                  </div>
                  <div class="card-body ">
                    <div class="form-group "><!--input-group-->
                      <!--                                            <div class="input-group-prepend">-->
                      <!--                                                <span class="input-group-text">-->
                      <!--                                                </span>-->
                      <!--                                            </div>-->
                      <input type="text" required class="form-control" placeholder="Enter Your Code" v-model="twoFACode">
                    </div>
                    <div class="custom-control custom-checkbox d-flex  mb-2">
                      <input type="checkbox" class="custom-control-input"  name="identifiers" v-model="remember_computer" :value="!remember_computer" id="remember_computer"/>
                      <label class="custom-control-label " for="remember_computer">Remember computer for 30 days</label>
                    </div>
                    <p class="text-danger text-center mb-0" v-if="feedback"><strong>{{ feedback }}</strong></p>
                  </div>
                  <div class="card-footer ">
                    <button type="submit" class="btn btn-warning btn-round btn-block mb-3" :disabled="disableVerifyBtn">{{ btnText }}</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <footer class="footer footer-black  footer-white ">
          <div class="container-fluid">
            <div class="row">
              <nav class="footer-nav">
                <ul>
                  <li>
                    <a href="https://www.bigscoots.com/" target="_blank">Bigscoots</a>
                  </li>
                  <li>
                    <a href="https://www.bigscoots.com/wordpress-optimized-hosting/" target="_blank">WordPress Hosting</a>
                  </li>
                  <li>
                    <a href="https://www.bigscoots.com/about-us/privacy-policy" target="_blank">Privacy Policy</a>
                  </li>
                  <li>
                    <a href="https://www.bigscoots.com/about-us/privacy-policy" target="_blank">SLA</a>
                  </li>
                </ul>
              </nav>
              <div class="credits ml-auto">
                <span class="copyright">
                  ©
                  {{ currentYear }}, made with
                  <i class="fa fa-heart heart"></i> by <a href="https://acnam.com" class="text-light" target="_blank">Acnam</a>
                </span>
              </div>
            </div>
          </div>
        </footer>
        <div class="full-page-background"></div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import { db, auth , messaging } from '@/firebase/init'
import { getMessaging, getToken } from "firebase/messaging";
import swal from 'sweetalert2';
import twoFAMixin from "../mixins/twoFAMixin";
export default {
  name: "TwoFA",
  mixins:[twoFAMixin],
  data(){
    return{
      twoFACode:'',
      display_msg:'',
      btnText:'Verify',
      disableVerifyBtn:false,
      loading:false,
      feedback:'',
      userData:null,
      remember_computer:false
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  },
  async created(){
    console.log(this.userUId);
    if(this.userUId){
      const resp = await this.$http.post('/2FO/generate_token',{
        grant_type: 'token',
        UID: this.userUId
      });
      this.display_msg = resp.data.msg;
      console.log(this.display_msg);
    }
    this.loading = true;

  },
  mounted() {
    document.body.classList.add('login-page')
    $('.form-control').on("focus", function() {
      $(this).parent('.input-group').addClass("input-group-focus");
    }).on("blur", function() {
      $(this).parent(".input-group").removeClass("input-group-focus");
    });
    window.addEventListener('popstate', () => {
      console.log('User clicked back button');
      window.open('/', '_self')
    });
  },
  beforeDestroy() {
    document.body.classList.remove('login-page')
  },
  methods:{
    async insertFcmToken(fcmTokenArray){
      try{
        const token = await messaging.getToken()
        if(Array.isArray(fcmTokenArray)){
          if(!fcmTokenArray.includes(token)){
            fcmTokenArray.push(token)
          }
        }
        else{
          fcmTokenArray= [fcmTokenArray, token];
        }
        await db.collection('users').doc(this.userUId).update({
          fcmToken: fcmTokenArray
        })
        return fcmTokenArray;
      }
      catch(e){
        console.log(e)
      }
    },
    async  verifycode(){
      let remember = this.$store.getters.getRememberCoumputer;
      console.log(remember);
      this.feedback = null;
      this.btnText = 'Verifying...';
      this.disableVerifyBtn = true;
      this.$http.post('/2FO/verify_token',{
        grant_type: 'token',
        twoFAToken: this.twoFACode,
        UID: this.userUId
      }).then(async () => {
        // try{
        await this.updateTwoFAVerified(true);
        const doc = await db.collection('users').doc(this.userUId).get();
        const user = {
          firstName: doc.data().firstName,
          lastName: doc.data().lastName,
          email: doc.data().email,
          userType: doc.data().userType,
          signature: doc.data().signature || '',
          hbName: doc.data().hbName || '',
          customerID: doc.data().customerID ? doc.data().customerID : null,
          uid: doc.id,
          notifications: doc.data().notifications ? doc.data().notifications : false,
          twoFA:doc.data().twoFA,
          stopStatusCake: doc.data().stopStatusCake,
          getNotificationStatus: (doc.data().getNotificationStatus ===undefined) ? false : doc.data().getNotificationStatus,
          fcmToken : doc.data().fcmToken
        };
        try {
          const updatedFcmTokenArray= await this.insertFcmToken(doc.data().fcmToken);
          user.fcmToken = updatedFcmTokenArray;
        } catch (e) {
          console.log('error while saving fcm token', e.toString())
        }
        // Also dispatch the details to Vuex store
        this.$store.dispatch('updateUserDetails', user);

        // Store the received data about the user in the Local Storage
        localStorage.setItem('userDtls', JSON.stringify(user));

        auth.currentUser.getIdToken().then((idToken)=>{
          this.$store.dispatch('updateUserDetails', {...user, idToken: idToken})
          localStorage.setItem('userDtls', JSON.stringify({...user, idToken: idToken}))
        });

        this.$store.dispatch("customer/allDetailsUpdate", {...doc.data(), uid: doc.id, docID: doc.id});

        if(this.remember_computer){
          // set a cookie for 30 Days if user does enabled 2FA
          this.$cookie.set('login-session', true, { expires: '30D' });
        }else{
          // set a cookie for 24hours if user does not have 2FA
          this.$cookie.set('login-session', true, { expires: '24h' });
        }

        // Check what kind of a user is this by checking userType of the received data
        // if userType === admin then redirect to admin page
        if(user.userType === 'admin' || user.userType === 'manager') {
          this.$router.push({ name: 'betteruptime' });
        } else {
          this.$router.push({ name: 'userDashboard' });
        }

        this.btnText = 'Verify';
        this.disableVerifyBtn = false;
        this.addLog({
          name: user.firstName + " " + user.lastName,
          message: "Logged in",
          level:  "info"
        })
      }).catch((e)=>{
        if(e.response.status === 422){
          this.btnText = 'Verify';
          this.disableVerifyBtn = false;
          this.feedback = 'Invalid Token';
          // swal('Invalid Token', '', 'error');
          return false;
        }
      });
    }
  }
}

</script>

<style lang="scss">
.login-page {
  .full-page-background {
    background-image: url('../assets/img/bg/fabio-mangione.jpg');
  }
  .section-image{
    &:after {
      background-color: rgba(90, 124, 253, 0.94)
    }
  }
  .login-bs-logo {
    max-height: 60px;
  }
}
</style>
